import { ExcelOptions } from "../models/excel-options";

export abstract class IExcelParser {
    abstract parse(data: any[], config: ExcelOptions)
}
